<template>
  <div class="main">
    <heads></heads>
    <navs></navs>
    <banners></banners>
    <div class="content">
      <div class="con-main">
        <div class="con-left">
          <div class="con-left-title">
            <div class="con-left-title-nav">
              <router-link :to="{ path: '/', query: { idx: 0 } }"
                >首页</router-link
              >
            </div>
            <div class="con-left-title-nav">></div>
            <div class="con-left-title-nav">
              <router-link :to="{ path: '/hdzq/list' }">活动专区</router-link>
            </div>
            <div class="con-left-title-nav">></div>
            <div class="con-left-title-nav">
              “科普进校园，健康护成长”——科普公益大讲堂活动
            </div>
            <div class="con-left-title-btn">
              <el-button type="primary" size="small" @click="comeback"
                >返回上级</el-button
              >
            </div>
          </div>
          <div class="con-left-xq">
            <div class="xinhuodong">
              <div class="xinhuodong-title">
                <div class="xinhuodong-title-dbt">
                  “科普进校园，健康护成长”——科普公益大讲堂活动
                </div>
                <div class="xinhuodong-title-xbt">
                  主办单位：重庆科普作家协会、重庆医科大学附属大学城医院、重庆医科大学附属第二医院、重庆市中医院、重庆医科大学附属儿童医院、重庆医科大学护理学院
                </div>
                <div class="xinhuodong-title-tgq">
                  <!-- <div class="xinhuodong-title-tgq-line">
                    <span>申报数：</span>{{ tougaoshu }}
                  </div> -->
                  <div class="xinhuodong-title-tgq-line">
                    <span>截止日期：</span>{{ jiezhiriqi }}
                  </div>
                  <div class="xinhuodong-title-tgq-line">
                    <div
                      class="xinhuodong-title-tgq-line-btn xinhuodong-title-tgq-line-btn1"
                      @click="clicklijitougao"
                    >
                      立即申报
                    </div>
                    <div
                      class="xinhuodong-title-tgq-line-btn xinhuodong-title-tgq-line-btn2"
                      @click="tiaozhuangrzx"
                    >
                      查看报名
                    </div>
                  </div>
                </div>
              </div>
              <div class="xinhuodong-con">
                <el-tabs v-model="activeName" class="demo-tabs">
                  <el-tab-pane label="活动介绍" name="huodongjieshao">
                    <div class="hdjs-wz" v-html="huodongcontent"></div>
                  </el-tab-pane>
                  <el-tab-pane label="名单公示" name="mingdangongshi">
                    <div class="zuopin-ul">
                      <div
                        class="zuopin-list"
                        v-for="(item, key) in zuopinlist"
                        :key="key"
                      >
                        <div class="zuopin-list-title">
                          {{ item.hdname }}
                        </div>
                        <div class="zuopin-list-subtitle">
                          申请类别：{{ item.sqlb }}
                        </div>
                        <div class="zuopin-list-subtitle">
                          单位/学校：{{ item.org }}
                        </div>
                        <div class="zuopin-list-btns">
                          <!-- <div class="zuopin-list-btns-zz">
                            <el-icon :size="size" :color="color">
                              <User />
                            </el-icon>
                            <span>{{ item.username }}</span>
                          </div> -->
                          <el-button
                            type="primary"
                            :icon="Search"
                            @click="clickchakan(item.Id)"
                            >查看</el-button
                          >
                        </div>
                      </div>
                    </div>
                    <div class="con-main-nr-fy">
                      <el-pagination
                        size="small"
                        background
                        layout="prev, pager, next"
                        :total="total"
                        @current-change="fenye"
                      />
                    </div>
                  </el-tab-pane>
                </el-tabs>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <footers></footers>
    <!-- 活动详情弹窗 -->
    <el-dialog v-model="dialogTableVisible" title="申报详情" width="800">
      <div class="zuopinxiangqing-jcxx">
        <div class="zuopinxiangqing-jcxx-title">基础信息</div>
        <div class="zuopinxiangqing-jcxx-con">
          <div class="zuopinxiangqing-jcxx-cons">
            <span class="zuopinxiangqing-jcxx-cons-sp1">活动名称：</span>
            <span class="zuopinxiangqing-jcxx-cons-sp2">{{
              zuopinobj.zuopin.hdname
            }}</span>
          </div>
          <div class="zuopinxiangqing-jcxx-cons">
            <span class="zuopinxiangqing-jcxx-cons-sp1">申请类别：</span>
            <span class="zuopinxiangqing-jcxx-cons-sp2">{{
              zuopinobj.zuopin.sqlb
            }}</span>
          </div>
          <div class="zuopinxiangqing-jcxx-cons">
            <span class="zuopinxiangqing-jcxx-cons-sp1">单位/学校</span>
            <span class="zuopinxiangqing-jcxx-cons-sp2">{{
              zuopinobj.zuopin.org
            }}</span>
          </div>
        </div>
      </div>
      <!-- <div class="zuopinxiangqing-fj">
        <div class="zuopinxiangqing-jcxx-title">附件</div>
        <div class="zuopinxiangqing-fj-con"> 
          <div class="zuopinxiangqing-fj-cons">
            <el-icon :size="'16'"> <Link /> </el-icon
            ><a :href="zuopinobj.zuopin.sqbfile">下载申请表</a>
          </div>
        </div>
      </div> -->
    </el-dialog>
    <!-- 立即申报弹窗 -->
    <el-dialog v-model="dialogTableVisibletougao" title="申报" width="800">
      <div class="tougao-buzou">
        <el-steps :active="tougaoactive" finish-status="success">
          <el-step title="材料承诺书" />
          <el-step title="上传材料" />
        </el-steps>
      </div>
      <div class="tougao-con">
        <!-- 第一步 -->
        <div class="tougao-cons" v-show="tougaoactive == 0">
          <div class="tougao-cons-duanluo">
            <p>
              本申报人\学校自愿参加2024年“科普进校园，健康护成长”——科普公益大讲堂活动（以下简称“活动”），保证提交材料不得出现以下情况：
            </p>
            <p>（1）反对宪法确定的基本原则；</p>
            <p>（2）危害国家统一、主权和领土完整；</p>
            <p>（3）泄露国家秘密、危害国家安全或者损害国家荣誉和利益；</p>
            <p>
              （4）煽动民族仇恨、民族歧视，破坏民族团结，或者侵害民族风俗、习惯；
            </p>
            <p>（5）宣扬邪教、迷信；</p>
            <p>（6）扰乱社会秩序，破坏社会稳定；</p>
            <p>（7）宣扬淫秽、赌博、暴力或者教唆犯罪；</p>
            <p>（8）侮辱或者诽谤他人，侵害他人合法权益；</p>
            <p>（9）危害社会公德或者民族优秀文化传统；</p>
            <p>（10）法律、行政法规和国家规定禁止的其他内容。</p>
            <p>若发生前述问题，一切责任由申报人\学校承担。</p>
          </div>
          <div class="tougao-cons-caozuo">
            <div class="tougao-cons-caozuos">
              <el-checkbox v-model="tougaochecked" label="我同意以上协议" />
            </div>
            <div class="tougao-cons-caozuos tougao-cons-caozuos-btn">
              <el-button
                @click="click1"
                :disabled="!tougaochecked"
                type="primary"
                >下一步</el-button
              >
            </div>
          </div>
        </div>
        <!-- 第2部 -->
        <div class="tougao-cons" v-show="tougaoactive == 1">
          <div class="tougao-cons-duanluo">
            <el-form
              label-width="100px"
              :model="formLabelAlign"
              :rules="baseRules"
              ref="ruleFormRef"
            >
              <!-- <el-form-item label="名称" required prop="title">
                <el-input
                  v-model="formLabelAlign.title"
                  placeholder="请输入名称"
                />
              </el-form-item> -->
              <el-form-item label="单位/学校" required prop="org">
                <el-input
                  v-model="formLabelAlign.org"
                  placeholder="请输入单位/学校"
                />
              </el-form-item>
              <el-form-item label="申请类别" required prop="sqlb">
                <el-select
                  v-model="formLabelAlign.sqlb"
                  placeholder="请选择申请类别"
                  style="width: 660px"
                >
                  <el-option
                    v-for="item in optionszpxs"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
              <el-form-item label="上传申请表" required>
                <el-upload
                  v-model:file-list="fileList"
                  class="upload-demo"
                  action="#"
                  list-type="text"
                  :limit="1"
                  accept=".doc, .docx"
                  :on-exceed="handleExceed"
                  :before-upload="handlePreview"
                  :before-remove="handleRemove"
                  :http-request="upload"
                >
                  <el-button type="primary">上传申请表</el-button>
                  <template #tip>
                    <div class="el-upload__tip">
                      <a
                        href="https://ketanghd-1304761361.cos.ap-nanjing.myqcloud.com/mb/%E7%A7%91%E6%99%AE%E8%BF%9B%E6%A0%A1%E5%9B%AD%E5%81%A5%E5%BA%B7%E6%8A%A4%E6%88%90%E9%95%BF%E7%94%B3%E8%AF%B7%E8%A1%A8.zip"
                        >申请表下载</a
                      >
                      <div>请上传.doc或者.docx格式文件</div>
                    </div>
                  </template>
                </el-upload>
              </el-form-item>
            </el-form>
          </div>
          <div class="tougao-cons-caozuo">
            <div class="tougao-cons-caozuos tougao-cons-caozuos-btn">
              <el-button @click="tougaoactive = 1">上一步</el-button
              ><el-button @click="submitinfo(ruleFormRef)" type="primary"
                >提交待审</el-button
              >
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script setup>
import { User } from "@element-plus/icons-vue";
import { ElMessage } from "element-plus";
import COS from "cos-js-sdk-v5";
// vuex
import { useStore } from "vuex";
const store = useStore();
// router
import { useRouter } from "vue-router";
const router = useRouter();
import { get, post } from "@/utils/index";
import { ref, reactive, getCurrentInstance } from "vue";
import {
  Delete,
  Edit,
  Search,
  Share,
  Upload,
  Link,
} from "@element-plus/icons-vue";
const { proxy } = getCurrentInstance();

// tab初始值
let activeName = ref("huodongjieshao");
// 活动的html代码
let huodongcontent = ref("");
let jiezhiriqi = ref("");
let tougaoshu = ref(0);
// 分页 全部作品
let psize = ref(9);
let pindex = ref(1);
let total = ref(0);
let zuopinleixing = ref(0); //0 全部   2优秀
// 是否显示活动详情弹窗
let dialogTableVisible = ref(false);
let dialogTableVisibletougao = ref(false);
// 投稿弹窗
let tougaoactive = ref(0);
let tougaochecked = ref(false);
// 申请类别
const optionszpxs = [
  {
    value: "专家",
    label: "专家",
  },
  {
    value: "学校",
    label: "学校",
  },
];
let formLabelAlign = reactive({
  wzid: router.currentRoute.value.query.id,
  hdname: "“科普进校园，健康护成长”——科普公益大讲堂活动",
  // title: "",
  org: "",
  sqlb: "",
  sqbfile: "",
});
const ruleFormRef = ref();
const baseRules = {
  // title: [{ required: true, message: "名称不能为空", trigger: "blur" },{ min: 3, max: 50, message: '名称长度3-50字之间', trigger: 'blur' }],
  org: [{ required: true, message: "单位/学校不能为空", trigger: "blur" },{ min: 3, max: 50, message: '单位/学校长度3-50字之间', trigger: 'blur' }],
  sqlb: [{ required: true, message: "请选择申请类别", trigger: "blur" }],
};
// 全部作品列表
let zuopinlist = reactive([]);
let zuopinobj = reactive({
  zuopin: {},
});
// 上传
let fileList = ref([]);

let form = reactive({
  title: "", //报名表名
});
// 上传桶的filename  唯一key 报名表
let filename = "";

// 实例
const cos = new COS({
  // getAuthorization 必选参数
  getAuthorization: function (options, callback) {
    // 异步获取临时密钥
    let url = "http://114.67.207.172:8004/api/User/GetTencentSST"; // url 替换成您自己的后端服务
    let xhr = new XMLHttpRequest();
    xhr.open("GET", url, true);
    //发送合适的请求头信息
    xhr.setRequestHeader(
      "Content-Type",
      "application/json-patch+json;charset=UTF-8"
    );
    xhr.setRequestHeader(
      "Authorization",
      "Bearer " + window.localStorage.getItem("token") || ""
    );
    xhr.onload = function (e) {
      let resdata, credentials;
      try {
        resdata = JSON.parse(e.target.responseText);
        credentials = resdata.data.Credential.Credentials;
      } catch (e) {}
      if (!resdata || !credentials) {
        return console.error("credentials invalid");
      }

      callback({
        TmpSecretId: credentials.TmpSecretId,
        TmpSecretKey: credentials.TmpSecretKey,
        SecurityToken: credentials.Token,
        // 建议返回服务器时间作为签名的开始时间，避免用户浏览器本地时间偏差过大导致签名错误
        StartTime: resdata.data.Credential.StartTime, // 时间戳，单位秒，如：1580000000
        ExpiredTime: resdata.data.Credential.ExpiredTime, // 时间戳，单位秒，如：1580000000
      });
    };
    xhr.send();
  },
});

// 获取全部作品
const getallzuopin = () => {
  post("/api/Hd/GetHdKpjxyList", {
    keyword: "",
    yx: 0,
    page: pindex.value,
    psize: psize.value,
  }).then((res) => {
    zuopinlist.push(...res.data);
    total.value = res.total;
  });
};
getallzuopin();

// 获取详情
const getdetail = () => {
  get("/api/NewsPaper/GetNewsForm", {
    id: router.currentRoute.value.query.id,
  }).then((res) => {
    huodongcontent.value = res.data.NewsContent;
    jiezhiriqi.value = res.data.NewsTag;
  });
};
getdetail();

// 获取投稿数量
const gettougaoshu = () => {
  get("/api/Hd/GetHdKpjxyCount").then((res) => {
    tougaoshu.value = res.data;
  });
};
gettougaoshu();

// 到第二部
const click1 = () => {
  tougaoactive.value = 1;
};

// 提交待审
const submitinfo = (formEl) => {
  if (!formEl) return;
  if (form.title == "") {
    ElMessage({
      message: "请上传申请表",
      duration: 1000,
    });
    return;
  }
  formEl.validate((valid) => {
    // 通过验证规则 true
    if (valid) {
      post("/api/User/SubHdKpjxy", formLabelAlign).then((res) => {
        ElMessage({
          message: "提交成功，等待审核",
          duration: 1000,
          onClose: () => {
            formLabelAlign.title = "";
            formLabelAlign.org = "";
            formLabelAlign.sqlb = "";
            formLabelAlign.sqbfile = "";
            tougaoactive.value = 0;
            fileList.value = [];
            dialogTableVisibletougao.value = false;
          },
        });
      });
    }
  });
};

// 上传报名表
const upload = (params) => {
  // 自动标题
  form.title = params.file.name.split(".")[0];
  // 文件名不唯一
  filename = params.file.name.split(".")[0] + Date.now();
  // formLabelAlign.sqbfile =
  //   "https://yuanpingjia-com-cn-1304761361.cos.ap-chongqing.myqcloud.com/tougao/%E5%8A%A0%E5%90%88%E6%8A%95%E7%A8%BF%E7%B3%BB%E7%BB%9F%E4%BB%8B%E7%BB%8D.docx";
  cos.putObject(
    {
      Bucket: "ketanghd-1304761361" /* 填入您自己的存储桶，必须字段 */,
      Region: "ap-nanjing" /* 存储桶所在地域，例如ap-beijing，必须字段 */,
      Key:
        "kpjxy/" +
        filename +
        "." +
        params.file.name.split(
          "."
        )[1] /* 存储在桶里的对象键（例如1.jpg，a/b/test.txt），必须字段 */,
      Body: params.file,
    },
    function (err, data) {
      if (data.statusCode === 200) {
        formLabelAlign.sqbfile = "https://" + data.Location;
      } else {
        ElMessage({
          message: "上传失败：" + err,
          type: "error",
        });
      }
    }
  );
};

// 超出限制
const handleExceed = (file) => {
  ElMessage({
    message: "只能上传一个文档",
    duration: 1000,
    type: "warning",
  });
};

// 上传之前
const handlePreview = (file) => {
  // 此处可以限制大小
  // ElMessage({
  //   message: "图片超出大小",
  //   duration: 1000,
  //   type: 'warning',
  // });
  // return false
};

// 删除文件
const handleRemove = (uploadFile, uploadFiles) => {
  // pictureUrl.value = "";
  form.title = "";
};

// 查看详情
const clickchakan = (id) => {
  // 根据id获取详情
  get("/api/Hd/GetHdKpjxyDet", {
    id: id,
  }).then((res) => {
    //zuopinlist.push(...res.data)
    zuopinobj.zuopin = res.data;
  });
  dialogTableVisible.value = true;
};

// 分页 全部作品
const fenye = (value) => {
  pindex.value = value;
  getallzuopin();
};

// 返回
const comeback = () => {
  router.push({
    path: "/hdzq/list",
  });
};
// 查看投稿
const tiaozhuangrzx = () => {
  let token = window.localStorage.getItem("token") || "";
  if (token && token != "") {
    router.push({
      path: "/pchd",
      query: {
        idx: -1,
      },
    });
  } else {
    // 清除token
    window.localStorage.removeItem("token");
    // 保存当前地址以便登录后返回
    window.localStorage.setItem("loginurl", window.location.href);
    ElMessage({
      message: "请登录",
      type: "warning",
      duration: 1000,
      onClose: () => {
        // 跳转登录页
        router.push({
          path: "/login",
          query: {},
        });
      },
    });
  }
};

// 点击立即投稿判断登录
const clicklijitougao = () => {
  let token = window.localStorage.getItem("token") || "";
  if (token && token != "") {
    dialogTableVisibletougao.value = true;
  } else {
    // 清除token
    window.localStorage.removeItem("token");
    // 保存当前地址以便登录后返回
    window.localStorage.setItem("loginurl", window.location.href);
    ElMessage({
      message: "请登录",
      type: "warning",
      duration: 1000,
      onClose: () => {
        // 跳转登录页
        router.push({
          path: "/login",
          query: {},
        });
      },
    });
  }
};
</script>

<style scoped>
::v-deep(.el-upload__tip) {
  display: flex;
}
::v-deep(.el-steps) {
  width: 100%;
}
::v-deep .el-carousel__container {
  height: 200px;
}
.main {
  background: #fff;
}
.con-main {
  width: 1200px;
  margin: auto;
  margin-bottom: 30px;
}
.con-main:after {
  content: "";
  display: table;
  clear: both;
}
a:link,
a:visited {
  text-decoration: none;
  color: #333;
}
a:hover {
  color: #777;
}
.con-left {
  width: 100%;
  height: auto;
  float: left;
  padding-bottom: 50px;
}

.con-left-title {
  font-weight: bold;
  padding: 20px 0 0 0;
  box-sizing: border-box;
}
.con-left-title:after {
  content: "";
  display: table;
  clear: both;
}
.con-left-title-nav {
  float: left;
  height: 30px;
  line-height: 30px;
  margin-right: 10px;
  font-size: 14px;
}

.con-left-fy {
  padding: 30px 0;
}

.con-left-title-btn {
  display: flex;
  align-items: center;
  float: right;
}

.xinhuodong {
  width: 100%;
  height: auto;
  box-sizing: border-box;
  border-radius: 5px;
  margin: 20px 0 0 0;
  padding: 20px;
  background: #fff;
  box-shadow: 0 0 8px rgba(6, 56, 115, 0.1);
}
.xinhuodong-title {
  position: relative;
  width: 1160px;
  height: 210px;
  background-image: url("../../assets/img/hdzq/activitybj.c75e0b23.png");
  background-size: 100% 100%;
  margin-bottom: 20px;
}
.xinhuodong-title-dbt {
  position: absolute;
  left: 20px;
  top: 55px;
  width: 660px;
  line-height: 36px;
  font-size: 22px;
}
.xinhuodong-title-xbt {
  position: absolute;
  left: 20px;
  top: 100px;
  width: 660px;
  font-size: 18px;
  color: #666;
}
.xinhuodong-title-tgq {
  position: absolute;
  top: 30px;
  right: 50px;
  width: 360px;
  height: 150px;
  background: #fff;
  box-shadow: 0 0 8px rgba(6, 56, 115, 0.1);
  border-radius: 5px;
  padding: 10px 50px;
  box-sizing: border-box;
}
.xinhuodong-title-tgq-line {
  font-size: 18px;
  margin: 18px 0;
}
.xinhuodong-title-tgq-line > span {
  color: #999;
}
.xinhuodong-title-tgq-line-btn {
  width: 110px;
  height: 50px;
  color: #fff;
  text-align: center;
  line-height: 50px;
  font-size: 18px;
  border-radius: 5px;
  float: left;
  cursor: pointer;
}
.xinhuodong-title-tgq-line-btn:after {
  content: "";
  display: table;
  clear: both;
}
.xinhuodong-title-tgq-line-btn:hover {
  opacity: 0.9;
}
.xinhuodong-title-tgq-line-btn1 {
  background: #2c5dfe;
  margin-right: 20px;
}
.xinhuodong-title-tgq-line-btn2 {
  background: #67c23a;
}
.zuopin-list {
  display: inline-block;
  position: relative;
  width: calc(33.33% - 20px);
  height: auto;
  margin: 10px;
  padding: 10px;
  font-size: 14px;
  line-height: 20px;
  background-color: #fff;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
  vertical-align: top;
  box-sizing: border-box;
}
.zuopin-list-title {
  font-size: 16px;
  font-weight: bold;
  line-height: 24px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.zuopin-list-subtitle {
  padding: 5px 0 0 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.zuopin-list-btns {
  border-top: 1px solid #ddd;
  margin-top: 10px;
  padding-top: 10px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.zuopin-list-btns-zz {
  width: 250px;
  height: 40px;
  display: flex;
  align-items: center;
}
.zuopin-list-btns-zz > span {
  padding-left: 5px;
}
.con-main-nr-fy {
  padding: 20px 0;
  display: flex;
  justify-content: center;
}

.zuopinxiangqing-jcxx-title {
  border-bottom: 1px solid #ddd;
  padding-bottom: 10px;
  font-weight: bold;
}
.zuopinxiangqing-jcxx-cons:after {
  content: "";
  display: table;
  clear: both;
}
.zuopinxiangqing-jcxx-cons-sp1 {
  float: left;
  width: 100px;
  height: 26px;
  line-height: 26px;
}
.zuopinxiangqing-jcxx-cons-sp2 {
  float: right;
  width: calc(100% - 100px);
  min-height: 26px;
  line-height: 26px;
}
.zuopinxiangqing-jcxx-con {
  padding: 10px 0;
}
.zuopinxiangqing-fj a:link,
.zuopinxiangqing-fj a:visited {
  color: #2c5dfe;
}
.zuopinxiangqing-fj a:hover {
  text-decoration: underline;
}
.zuopinxiangqing-fj-con {
  padding: 10px 0;
}
.zuopinxiangqing-fj-cons {
  width: 100%;
  height: 26px;
  display: flex;
  align-items: center;
}
.zuopinxiangqing-fj-cons a {
  margin-left: 5px;
}
.zuopinxiangqing-fj {
  padding-top: 20px;
}

/* 步骤弹窗 */
.tougao-buzou {
  width: 100%;
  display: flex;
  justify-content: center;
}
.tougao-con {
  padding: 30px 0;
}
.tougao-cons-duanluo > p {
  line-height: 24px;
  margin: 8px 0;
}
.tougao-cons-caozuos-btn {
  margin-top: 30px;
  display: flex;
  justify-content: center;
}
.tougao-cons-duanluo-title {
  font-weight: bold;
}
.baomingbiao {
  position: relative;
}
.baomingbiao a {
  position: absolute;
  left: 18px;
  top: 36px;
}
.baomingbiao a:link,
.baomingbiao a:visited {
  color: #2c5dfe;
  text-decoration: underline;
}
.el-upload__tip a {
  margin: 0 10px 0 0;
}
.el-upload__tip a:link,
.el-upload__tip a:visited {
  text-decoration: underline;
  color: #2c5dfe;
}
</style>
